export default __webpack_public_path__ + "static/logo_256_oneDODO-497aa40e6cd1e69060b9d0595ba6c1b8.svg";